module.exports = __webpack_public_path__ + "img/tbi.bb7168f0.jpg";